import { Trophy, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { useLang } from "../context/LanguageContext";
import { EXTRA } from "../content/extra";

export const HALL_OF_FAME_URL = "/hall-of-fame";

export const HallOfFame = () => {
  const { lang } = useLang();
  const h = EXTRA[lang].hallOfFame;

  return (
    <section
      id="hall-of-fame"
      data-testid="hall-of-fame-section"
      className="relative z-10 py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5 overflow-hidden"
    >
      {/* glow */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D4AF37]/8 blur-[120px] rounded-full pointer-events-none" />

      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <Reveal>
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="absolute inset-0 bg-[#D4AF37]/30 blur-2xl rounded-full" />
              <div className="relative w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-b from-[#F2E3C6] to-[#D4AF37] text-black shadow-[0_10px_40px_rgba(212,175,55,0.4)] ring-1 ring-[#F2E3C6]/50">
                <Trophy size={34} strokeWidth={1.75} />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-5">
            <span className="h-px w-8 bg-[#D4AF37]/60" />
            {h.overline}
            <span className="h-px w-8 bg-[#D4AF37]/60" />
          </div>

          <h2 className="font-display text-4xl md:text-5xl tracking-tight gold-gradient-text leading-tight">
            {h.title}
          </h2>

          <p className="text-white/60 text-lg leading-relaxed mt-6 max-w-2xl mx-auto">
            {h.text}
          </p>

          <Link
            to={HALL_OF_FAME_URL}
            data-testid="hall-of-fame-button"
            className="group inline-flex items-center justify-center gap-2 mt-10 bg-[#D4AF37] text-black font-semibold px-9 py-4 hover:bg-[#F2E3C6] transition-colors duration-300"
          >
            <Trophy size={18} strokeWidth={2} />
            {h.button}
            <ArrowRight size={18} className="group-hover:translate-x-0.5 transition-transform duration-300" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
